module.exports = __webpack_public_path__ + "img/bg07.2b923098.gif";